import React from "react";

import { Loader } from "lucide-react";

interface PageLoaderProps {
  className?: string;
  show?: boolean;
  message?: string;
}
const PageLoader: React.FC<PageLoaderProps> = ({
  className = "",
  show = false,
  message = "",
}) => {
  return (
    <div
      className={
        "fixed top-0 left-0 w-full h-full z-[999999] glass-2 " +
        className +
        " " +
        (show ? "" : "hidden")
      }
      style={{ backgroundColor: "#00000030" }}
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-4">
        <Loader className="animate-spin" size={50} />
        <div className="opacity-60">{message}</div>
      </div>
    </div>
  );
};

export default PageLoader;
